export default {"src":"/_next/static/media/quotation-marks.47619fd4.svg","height":38,"width":51};